import { hookstate, useHookstate } from "@hookstate/core"

const scansState = hookstate([])
export const useScansState = () => {
  return useHookstate(scansState)
}
export const useScans = () => {

  const scans = useScansState()

  return {
    scans: scans.get(),
    setScans: scans.set
  }
}
